import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { cvtAwaitingApproval } from '@src/data/creditapp-selectors'
import { Box, ButtonGroup, Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import SignManuallyButton from './SignManuallyButton'
import CreateContractButton from './CreateContractButton'
import SignDigitallyButton from './SignDigitallyButton'
import ContractInformation from './ContractInformation'

interface Props {
  creditApp: CreditApplication
  isExpiryFeatureActive?: boolean
  isExpired?: boolean
}
const ContractAwaitingSignature = ({
  creditApp,
  isExpiryFeatureActive = false,
  isExpired = false,
}: Props) => {
  return (
    <>
      <ContractInformation creditApp={creditApp} isExpiryFeatureActive={isExpiryFeatureActive} />

      {isExpired ? (
        <Stack spacing={1}>
          <Typography sx={{ fontSize: '0.8rem' }} color="text.secondary">
            <Trans
              i18nKey="worksheet.contractExpiredExplanation"
              components={{
                r: <Box component="span" sx={{ color: 'error.main', fontWeight: 600 }} />,
                b: <strong />,
              }}
            />
          </Typography>
          <CreateContractButton creditApp={creditApp} isUpdateMode />
        </Stack>
      ) : (
        <Stack spacing={1}>
          {!cvtAwaitingApproval(creditApp.requiredDocuments) && <CreateContractButton creditApp={creditApp} />}

          <ButtonGroup size="small">
            <SignDigitallyButton creditApp={creditApp} />
            <SignManuallyButton creditApp={creditApp} />
          </ButtonGroup>
        </Stack>
      )}
    </>
  )
}

export default ContractAwaitingSignature
